// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
let Bootstrap = require('bootstrap')
import 'font-awesome/css/font-awesome.css'
import 'bootstrap/dist/css/bootstrap.css'

import Vue from 'vue'
import App from './App'
import router from './router'

// Import Vue and vue-highlgihtjs
import VueHighlightJS from 'vue-highlightjs'
// Tell Vue.js to use vue-highlightjs
Vue.use(VueHighlightJS)
import 'highlight.js/styles/a11y-dark.css'

Vue.config.productionTip = false


router.afterEach(route => {
    document.title = route.meta.title;
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js